import { createSelector } from 'reselect';
import { getSearchURL } from '../reducer';

const getPathToSearch = createSelector(
  [getSearchURL],
  searchURL => searchURL.path,
);

export { getPathToSearch };
